import {format, isFuture, isValid, parseISO} from "date-fns";
import {pl} from "date-fns/locale";

export const formatPL = (date: Date, formatStr: string) => {
    return format(date, formatStr, {
        locale: pl
    });
};

export const dateTimeFormat = {
    standard: "dd MMMM yyyy",
    shortDate: "dd.MM.yyyy",
    shortDateDashed: "dd-MM-yyyy",
    // longDate: "d MMMM yyyy",
    shortDateTime: "dd.MM.yyyy HH:mm",
    longDateTime: "d MMMM yyyy, HH:mm",
    // time: "HH:mm",
    quarter: "Q 'kw.' yyyy",
    // year: "yyyy",
    dashedDateFormat: "yyyy-MM-dd"

    // verboseMonthDatePL: "LL",
    // verboseShortMonthDatePL: "ll",
    // verboseLongDayOfWeekPL: "dddd",
    // numeralDayOfWeek: "d",
    // numeralDayOfMonth: "D",
    // verboseMonthNamePL: "MMMM"
};

export const formatDate = (dateString: string | null = null, dateFormat = dateTimeFormat.standard, timezoneHandler = (date: Date): Date => date): string => {
    const date = dateString ? parseISO(dateString) : new Date();

    if (!isValid(date)) {
        return "";
    }

    const unformattedDate = timezoneHandler(date);

    return formatPL(unformattedDate, dateFormat);
};

export const formatFutureDate = (dateString: string | null = null, dateFormat = dateTimeFormat.standard, readyPhrase?: string): string => {
    const date = dateString ? parseISO(dateString) : new Date();
    return isValid(date) ? (isFuture(date) ? formatPL(date, dateFormat) : readyPhrase ? readyPhrase : "gotowe") : "";
};

export const monthNominativeVerbose = (month: number) => {
    switch (month) {
        case 1:
            return "ze stycznia";
        case 2:
            return "z lutego";
        case 3:
            return "z marca";
        case 4:
            return "z kwietnia";
        case 5:
            return "z maja";
        case 6:
            return "z czerwca";
        case 7:
            return "z lipca";
        case 8:
            return "z sierpnia";
        case 9:
            return "z września";
        case 10:
            return "z października";
        case 11:
            return "z listopada";
        case 12:
            return "z grudnia";
        default:
            return;
    }
};

export const monthWhenVerbose = (month: number) => {
    switch (month) {
        case 1:
            return "styczniu";
        case 2:
            return "lutym";
        case 3:
            return "marcu";
        case 4:
            return "kwietniu";
        case 5:
            return "maju";
        case 6:
            return "czerwcu";
        case 7:
            return "lipcu";
        case 8:
            return "sierpniu";
        case 9:
            return "wrześniu";
        case 10:
            return "październiku";
        case 11:
            return "listopadzie";
        case 12:
            return "grudniu";
        default:
            return;
    }
};
